module.exports = __webpack_public_path__ + "img/ci.f19d0b8b.svg";